import { styled } from '@mui/material/styles';

export const TwoColumnsRow = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'calc(50% - 8px) calc(50% - 8px)',
    gridGap: 16,
    '@media (max-width: 768px)': {
        gridTemplateColumns: '100%',
        gridGap: 12,
    },
});
